module.exports = __webpack_public_path__ + "static/img/case7.6b885732.jpg";